module.exports = __webpack_public_path__ + "static/media/logo_v2.185310ff.svg";